import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllDestinations = async () => {
  try {
    const { data } = await AxiosInstance.get("/destination");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Create Destination
export const createDestination = async (destination) => {
  try {
    console.log(destination);
    const { data } = await AxiosInstance.post("/destination", destination, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Update Destination
export const updateDestination = async (destination) => {
  try {
    const { data } = await AxiosInstance.put("/destination", destination);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Delete Destination
export const deleteDestination = async (destination) => {
  try {
    const { data } = await AxiosInstance.delete(
      `/destination/${destination._id}`
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
